import React from 'react';
import PropTypes from 'prop-types';
import { InputBase } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CloseIcon from '@material-ui/icons/Close';
import DetailedChip from '../DetailedChip';

const renderInput = (params) => <InputBase {...params.InputProps} inputProps={params.inputProps} />;

const InputWithChips = ({
  classes,
  id,
  value,
  showAllItems,
  labelPropertyName,
  onInputChange,
  onDeleteChip,
  onInputFocus,
  InputProps,
  hideDeleteChipButton,
  isTextMessage,
  shouldNavigateToClientProfile,
  onClickChip,
  ...props
}) => {
  const onInputChangeHandler = (e, value) => onInputChange(value);
  const onDeleteChipHandler = (option) => () => onDeleteChip(option);
  const renderDetailedChip = (option, index, getTagProps) => (
    <DetailedChip
      isTextMessage={isTextMessage}
      data-testid="chip"
      option={option}
      label={option[labelPropertyName]}
      deleteIcon={<CloseIcon onClick={onDeleteChipHandler} />}
      classes={{ closeIcon: classes.deleteIcon }}
      {...getTagProps({ index })}
      onDelete={!hideDeleteChipButton ? onDeleteChipHandler(option) : null}
      shouldNavigateToClientProfile={shouldNavigateToClientProfile}
      onClickChip={onClickChip}
    />
  );

  return (
    <Autocomplete
      multiple
      open={false}
      id={id}
      popupIcon={null}
      disableClearable
      onInputChange={onInputChangeHandler}
      onFocus={onInputFocus}
      getOptionLabel={(option) => option[labelPropertyName]}
      value={value}
      freeSolo
      options={[]}
      classes={{
        root: classes.autocompleteRoot,
        inputRoot: classes.input,
        tag: classes.tag,
      }}
      renderTags={(value, getTagProps) =>
        !showAllItems
          ? renderDetailedChip(value[0], 0, getTagProps)
          : value.map((option, index) => renderDetailedChip(option, index, getTagProps))
      }
      renderInput={(params) =>
        renderInput({
          ...params,
          InputProps: {
            ...params.InputProps,
            ...InputProps,
            startAdornment: (
              <>
                {InputProps.startAdornment}
                {params.InputProps.startAdornment}
              </>
            ),
          },
        })
      }
      {...props}
    />
  );
};

InputWithChips.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  /** The id of the input element. */
  id: PropTypes.string.isRequired,
  /** The value of the autocomplete. */
  value: PropTypes.arrayOf(PropTypes.shape({})),
  /** If false, will display only first chip. */
  showAllItems: PropTypes.bool,
  /** Label that will be render from option object. */
  labelPropertyName: PropTypes.string.isRequired,
  /** Callback fired when the input value changes. */
  onInputChange: PropTypes.func,
  /** Callback fired when the delete icon is clicked. */
  onDeleteChip: PropTypes.func,
  /** Callback fired when the input recieve focus. */
  onInputFocus: PropTypes.func,
  InputProps: PropTypes.shape({}),
};

InputWithChips.defaultProps = {
  classes: {},
  value: [],
  showAllItems: true,
  InputProps: {},
};

export default InputWithChips;
